// removed by extract-text-webpack-plugin
module.exports = {"cells":"Cells__cells___1Qh4G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cells/Cells.css
// module id = 825
// module chunks = 0